import "./SafetyShield.css";
import { GiAnchor } from "react-icons/gi";
import { MdShield } from "react-icons/md";

function EngineeringSafety() {
  return (
    <section
      className="safety-hero"
      style={{
        backgroundImage: `url(${require("../assets/image/E2bg.jpg")})`,
      }}
    >
      <div class="hazard-container">
        <div class="hazard-header">
          <h1 class="hazard-title">
            <span class="title-line2">Hazard Management</span>
          </h1>
        </div>

        <ul class="hazard-list">
          <li class="hazard-item">
            <div className="decorative-icon">
              <GiAnchor />
            </div>
            <div class="content-wrapper">
              <p>
                Full-process hazard management to achieve closed-loop
                controllability
              </p>
            </div>
          </li>
          <li class="hazard-item">
            <div className="decorative-icon">
              <GiAnchor />
            </div>
            <div class="content-wrapper">
              <p>Multi-dimensional risk analysis to ensure foolproof</p>
            </div>
          </li>
          <li class="hazard-item">
            <div className="decorative-icon">
              <GiAnchor />
            </div>
            <div class="content-wrapper">
              <p>Quantized parameters provide accurate models for simulation</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="animated-shield">
        <MdShield className="Shieldicon" />
        <div className="shield-overlay">
          <h1>SAFETY</h1>
          <p>Animatronics, Show Set, Scenic</p>
        </div>
      </div>

      <div className="table-container">
        <table className="risk-table">
          <thead>
            <tr>
              <th className="element-col">Element</th>
              <th className="related-col">Related</th>
              <th className="stage-col">Stage</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Facility</td>
              <td>Designer/Manufacturer</td>
              <td>Concept Design</td>
            </tr>
            <tr>
              <td>Ride System</td>
              <td>Installer</td>
              <td>Deepening Design</td>
            </tr>
            <tr>
              <td>AVSC&Lighting</td>
              <td>Attraction Operation Team</td>
              <td>Installation & Checkout</td>
            </tr>
            <tr>
              <td>SFX/SAE</td>
              <td>Tech-service Team</td>
              <td>Commissioning & Verification</td>
            </tr>
            <tr>
              <td>Show Set/Prop</td>
              <td></td>
              <td>Operation & Maintenance</td>
            </tr>
            <tr>
              <td>Operation System</td>
              <td>
                <span className="capsule">Hazard identification</span>
              </td>
              <td>
                <span className="capsule">Risk estimation</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <span className="capsule">Risk evaluation</span>
              </td>
              <td>
                <span className="capsule">Risk reduction</span>
              </td>
            </tr>
          </tbody>
        </table>
        <h1 class="hazard-title-right">
          <span>Operation and Use Risk Assessment</span>
        </h1>
      </div>
    </section>
  );
}

export default EngineeringSafety;
